import { useQuery } from "@tanstack/vue-query";
import { computed, Ref } from "vue";

import KiliApi from "@/data/api/kili/kili-api";
import { SitesQueryKeys } from "@/data/api/kili/sites/sites-query-keys";

export function useGetSiteDetailsQuery(siteId: Ref<number>) {
  return useQuery({
    queryKey: SitesQueryKeys.details(siteId),
    queryFn: () => KiliApi.getSiteDetails({ params: { siteId: siteId.value } }),
    enabled: computed(() => siteId.value > 0),
  });
}
